import React from 'react';
import { withTranslation, Trans } from 'react-i18next';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import { Input } from '@progress/kendo-react-inputs';

const styles = theme => ({
  root: {
    flexGrow: 1,
  },
  paper: {
    ...theme.mixins.gutters(),
    paddingTop: theme.spacing.unit * 2,
    paddingBottom: theme.spacing.unit * 2,
  },
  chip: {
    margin: theme.spacing.unit,
  },
});
class PartnersListComponent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedIndex: '',
      partners: this.props.partners,
    };
  }

  componentDidUpdate() {
    if (this.props.partners && this.state.partners.length === 0) {
      this.setState({
        partners: this.props.partners,
      });
    }
  }

  handleListItemClick = (event, index, partnerid) => {
    this.setState({ selectedIndex: index });
    this.props.getOverview(partnerid);
  };

  searchHandler = event => {
    let query = event.target.value.toLowerCase();
    let partners = this.props.partners.filter(el => {
      let searchValue = el.name.toLowerCase();
      return searchValue.indexOf(query) !== -1;
    });
    this.setState({
      partners: partners,
    });
  };
  render() {
    // const { classes } = this.props;
    return (
      <div>
        <fieldset>
          <legend>
            <Trans>All partners</Trans>
          </legend>
          <Input label="Search" style={{ width: '100%' }} onChange={this.searchHandler} />
          <div style={{ height: '500px', overflow: 'scroll' }}>
            {/* <input type="text" name="" id="" /> */}
            <List component="nav">
              {this.state.partners.map((partner, i) => (
                <span key={i}>
                  <ListItem button selected={this.state.selectedIndex === i} onClick={e => this.handleListItemClick(e, i, partner.id)}>
                    <ListItemText primary={partner.name} />
                  </ListItem>
                </span>
              ))}
            </List>
          </div>
        </fieldset>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    partners: state.partners,
  };
};

const mapDispatchToProps = dispatch => {
  return {};
};

export default withTranslation()(
  withStyles(styles)(
    connect(
      mapStateToProps,
      mapDispatchToProps
    )(PartnersListComponent)
  )
);
